import { render, staticRenderFns } from "./RejectionDialog.vue?vue&type=template&id=593374aa&scoped=true"
import script from "./RejectionDialog.vue?vue&type=script&lang=js"
export * from "./RejectionDialog.vue?vue&type=script&lang=js"
import style0 from "./RejectionDialog.vue?vue&type=style&index=0&id=593374aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593374aa",
  null
  
)

export default component.exports